export default __webpack_public_path__ + "static/2-6--7cd0991609e3c7bc71f2747ec021446b.png";